/**
 * SeoTab - SEO settings management
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export function SeoTab({ content, setContent }) {
  const updateSeo = (field, value) => {
    setContent(prev => ({ ...prev, seo: { ...prev.seo, [field]: value } }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>SEO Settings</CardTitle>
        <CardDescription>Optimize your landing page for search engines</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <Label>Page Title</Label>
          <Input value={content.seo?.title || ''} onChange={(e) => updateSeo('title', e.target.value)} placeholder="e.g., Grassroots Coaching - Team Management Made Simple" />
          <p className="text-xs text-gray-500 mt-1">Appears in browser tab and search results (50-60 characters ideal)</p>
        </div>
        <div>
          <Label>Meta Description</Label>
          <Textarea value={content.seo?.description || ''} onChange={(e) => updateSeo('description', e.target.value)} rows={3} placeholder="Brief description for search results..." />
          <p className="text-xs text-gray-500 mt-1">Appears in search results (150-160 characters ideal)</p>
        </div>
        <div>
          <Label>Keywords</Label>
          <Input value={content.seo?.keywords || ''} onChange={(e) => updateSeo('keywords', e.target.value)} placeholder="e.g., team management, coaching app, grassroots football" />
          <p className="text-xs text-gray-500 mt-1">Comma-separated keywords</p>
        </div>
        <div className="border-t pt-4">
          <h4 className="font-medium text-gray-700 mb-4">Social Sharing (Open Graph)</h4>
          <div className="space-y-4">
            <div><Label>OG Title</Label><Input value={content.seo?.ogTitle || ''} onChange={(e) => updateSeo('ogTitle', e.target.value)} placeholder="Title when shared on social media" /></div>
            <div><Label>OG Description</Label><Textarea value={content.seo?.ogDescription || ''} onChange={(e) => updateSeo('ogDescription', e.target.value)} rows={2} placeholder="Description when shared on social media" /></div>
            <div>
              <Label>OG Image URL</Label>
              <Input value={content.seo?.ogImage || ''} onChange={(e) => updateSeo('ogImage', e.target.value)} placeholder="https://example.com/share-image.png" />
              <p className="text-xs text-gray-500 mt-1">Recommended: 1200x630 pixels</p>
            </div>
          </div>
        </div>
        <div className="border-t pt-4">
          <h4 className="font-medium text-gray-700 mb-4">Twitter Card</h4>
          <div className="space-y-4">
            <div><Label>Twitter Title</Label><Input value={content.seo?.twitterTitle || ''} onChange={(e) => updateSeo('twitterTitle', e.target.value)} placeholder="Title for Twitter shares" /></div>
            <div><Label>Twitter Description</Label><Input value={content.seo?.twitterDescription || ''} onChange={(e) => updateSeo('twitterDescription', e.target.value)} placeholder="Description for Twitter shares" /></div>
          </div>
        </div>
        <div className="border-t pt-4">
          <div>
            <Label>Canonical URL</Label>
            <Input value={content.seo?.canonicalUrl || ''} onChange={(e) => updateSeo('canonicalUrl', e.target.value)} placeholder="https://yourdomain.com" />
            <p className="text-xs text-gray-500 mt-1">The preferred URL for this page</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
